// Recovered compiled webpack factory 82984. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { u: () => n });
  let a = null;
  function n() {
    if (null !== a) return a;
    if ("undefined" == typeof document) return !1;
    try {
      var e;
      let t = document.createElement("canvas").getContext("webgl2");
      ((a = !!t),
        null == t || null == (e = t.getExtension("WEBGL_lose_context")) || e.loseContext());
    } catch {
      a = !1;
    }
    return a;
  }
}
